import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["view", "label", "tagName", "className"];
import { Text } from '@carnica/ui-kit';
import React, { useRef } from 'react';
import { combineRefs, forwardRefWithTag } from '@carnica/utils';
import { cnBem, useNodeObserver } from "../../lib";
import styles from "./styles.pcss";
var cnDivider = cnBem('divider', styles);
var checkiIsPinned = function checkiIsPinned(entry) {
  return entry.intersectionRatio > 0.9 && entry.intersectionRatio < 1;
};
export var Divider = forwardRefWithTag(function (props, ref) {
  var _props$view = props.view,
    view = _props$view === void 0 ? 'accent' : _props$view,
    label = props.label,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  var containerRef = useRef(null);
  var isDividerPinned = useNodeObserver({
    ref: containerRef,
    callback: checkiIsPinned,
    options: {
      threshold: [0.9, 1]
    }
  });
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnDivider({
      view: view,
      visible: isDividerPinned
    }, [className]),
    ref: combineRefs([ref, containerRef])
  }, otherProps), /*#__PURE__*/React.createElement(Text, {
    className: cnDivider('label', {
      view: view
    }),
    color: view === 'default' ? 'tertiary' : 'secondary-invert',
    variant: view === 'accent' ? 'caption-medium' : 'body-small'
  }, label));
});